import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';


const LogoutButton = () => {
  const { logout, isAuthenticated } = useAuth0();
  console.log(logout)

  return(
    isAuthenticated &&(
    <div>
      <p onClick={ () => logout()}>
        Log out
      </p>
    </div>
  )    
  ) 
}

export default LogoutButton;